<template>
  <section v-if="relatedPosts.posts.length" class="war-room-related-posts">
    <BravadoText tag="h2" variant="body semibold" class="war-room-related-posts__header">Related posts</BravadoText>
    <WarRoomPostPreviewRelated
      v-for="(post, index) in relatedPosts.posts"
      :key="post.slug"
      :post="post"
      :parent-post-id="parentPostId"
      :score="getScore(post)"
      class="war-room-related-posts__preview"
      @update-post="handleUpdatePost($event, index)"
      @on-poll-vote="handlePollVote"
    />
  </section>
</template>

<script lang="ts">
import Vue from 'vue';
import type { PropOptions } from 'vue';
import WarRoomPostPreviewRelated from '@/components/partials/war-room/WarRoomPostPreviewRelated.vue';
import { addVoter } from '@/components/partials/war-room/WarRoomPostPollV2/utils';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import type { IPost } from '@/types/community';
import type { WarRoom } from '@/types/store/warRoom';

interface IChoice {
  post: IPost;
  choiceId: number;
}

export default Vue.extend({
  name: 'WarRoomRelatedPosts',
  components: {
    WarRoomPostPreviewRelated,
    BravadoText,
  },
  props: {
    parentPostId: {
      type: Number,
      default: null,
    } as PropOptions<number | null>,
  },
  computed: {
    relatedPosts(): WarRoom.State['relatedPosts'] {
      return this.$store.state.warRoom.relatedPosts;
    },
  },
  methods: {
    handleUpdatePost(post: IPost, index: number) {
      this.$store.commit('warRoom/handleUpdatePost', { post, index });
    },
    getScore(post: IPost): number {
      return this.relatedPosts.relatedPostScoreDict[post.slug]?.score || 0;
    },
    async handlePollVote({ choiceId, post }: IChoice) {
      const updatedPoll = addVoter({ poll: post.poll, user: this.$auth.user!, choiceId });
      // @ts-ignore
      const postIndex = this.relatedPosts.posts.findIndex(({ id }) => id === post.id);
      const updatedPost = {
        ...post,
        poll: updatedPoll,
      };

      try {
        this.$analytics.logEvent('war-room__related-post__poll-choice__click', { choiceId });
        this.handleUpdatePost(updatedPost, postIndex);
        await this.$api.post(`/api/war_room/poll_votes.json`, {
          poll_vote: {
            choice_id: choiceId,
          },
        });
      } catch (e) {
        this.handleUpdatePost(post, postIndex);
        this.$sentryUtils.error(e);
      }
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-related-posts {
  &__header {
    margin-bottom: 12px;
    color: var(--gray-50);
  }

  &__preview {
    margin-bottom: 12px;
  }
}
</style>
